/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesMetaAdDataInputCountryDataSchema = z.object({
	id: z.string(),
})

export type ModulesMetaAdDataInputCountryDataSchema = z.infer<typeof modulesMetaAdDataInputCountryDataSchema>
